import React, { useContext, useEffect, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import AppContext from "../contexts/AppContext";
import useAuth from "../hooks/useAuth";
import { hasPermission, MenuSection, OperationType, routePermissions } from "./authRoles";

const getUserRoleAuthStatus = (pathname, user, routes) => {
  const matched = routes.find((r) => r.path === pathname);

  if (!user) return false;

  const authenticated =
    matched && matched.auth && matched.auth.length ? matched.auth.includes(user.role) : true;

  return authenticated;
};

const getRolePermission = (pathname, user) => {
  const mainPaths = ["/", "/dashboard"];

  if (mainPaths.includes(pathname)) {
    return true;
  }
  if (!user) return false;

  // Нормализуем путь перед проверкой
  const normalizedPath = pathname.replace(/\/\d+\/?$/, '');

  const permissionConfig = routePermissions[normalizedPath];
  if (!permissionConfig) return null;

  const type = MenuSection[permissionConfig.section];
  const operationType = OperationType[permissionConfig.operation];

  const hasPerm = hasPermission(type, operationType, user);

  return hasPerm;
};

const AuthGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  const [previouseRoute, setPreviousRoute] = useState(null);
  const { pathname } = useLocation();

  const { routes } = useContext(AppContext);
  // const isUserRoleAuthenticated = getUserRoleAuthStatus(pathname, user, routes);
  const hasPermission = getRolePermission(pathname, user);
  let authenticated = isAuthenticated;

  useEffect(() => {
    if (previouseRoute !== null) setPreviousRoute(pathname);
  }, [pathname, previouseRoute]);

  // if (authenticated && hasPermission) return <>{children}</>;
  if (!authenticated) {
    return (
      <Redirect
        to={{
          pathname: "/signin",
          state: { redirectUrl: previouseRoute },
        }}
      />
    );
  }
  if (hasPermission === null) {
    return (
      <Redirect
        to={{
          pathname: "/404",
          state: { redirectUrl: previouseRoute },
        }}
      />
    );
  }
  if (!hasPermission) {
    return (
      <Redirect
        to={{
          pathname: "/403",
          state: { redirectUrl: previouseRoute },
        }}
      />
    );
  }

  // Если всё в порядке
  return <>{children}</>;
};

export default AuthGuard;
